import { TableContainerComponent } from 'src/assets/styles/components/Table';
import ParentsMatchChildrenRow from '../../../../components/common/rows/ParentsMatchChildrenRow';

const StepParentMatchChildrenTable = (props) => {
  const { children, parent, getInfo, set_step, setParentInputs } = props;

  return (
    <TableContainerComponent>
      <table>
        <thead>
          <tr>
            <th>Foto</th>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Inscribir</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody>
          {children.map((kid) => (
            <ParentsMatchChildrenRow
              getInfo={getInfo}
              kid={kid}
              parent={parent}
              set_step={set_step}
              setParentInputs={setParentInputs}
            />
          ))}
        </tbody>
      </table>
    </TableContainerComponent>
  );
};

export default StepParentMatchChildrenTable;
